import React from 'react';
import { MAIN_CONTENT_ID } from '../components/SkipLink';

interface BareLayoutProps {
  children: React.ReactNode;
}

/** The layout for routes that render outside MainLayout/AdminLayout (login,
 *  register, the legal pages, and the onboarding and pending-approval states):
 *  it contributes only the `<main>`
 *  landmark those routes would otherwise lack, so every route carries exactly
 *  one main with the shared skip target. */
export const BareLayout: React.FC<BareLayoutProps> = ({ children }) => (
  <main id={MAIN_CONTENT_ID} tabIndex={-1}>
    {children}
  </main>
);
